import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import whatsapp from "../Assets/images/whatsapp.png";
import axiosInstance from "../axiosInterceptor";
import tutorLogo from "../Assets/icons/tutorImg.svg";

const Nav = () => {
  const [contact, setContact] = useState([]);

  const formatContactNumber = (countryName, contactNumber) => {
    switch (countryName) {
      case "India":
        return `+${contactNumber.slice(0, 2)} ${contactNumber.slice(
          2,
          7,
        )} ${contactNumber.slice(7)}`;
      case "Canada":
        return `+${contactNumber.slice(0, 1)} (${contactNumber.slice(
          1,
          4,
        )}) ${contactNumber.slice(4, 7)}-${contactNumber.slice(7)}`;
      case "Netherlands":
        return `+${contactNumber.slice(0, 2)} ${contactNumber.slice(
          2,
          5,
        )} ${contactNumber.slice(5, 7)} ${contactNumber.slice(7)}`;
      default:
        return contactNumber;
    }
  };

  const fetchContactData = async () => {
    try {
      const res = await axiosInstance.get(
        `/admin/contactNumber/getContactNumbers`,
      );
      setContact(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchContactData();
  }, []);

  return (
    <div className="bg-color-darker pt-3 pb-3">
      <div className="container px-3">
        <div className="flex-wrap flex-md-nowrap align-items-center justify-content-between color-white nav-new gap-2">
          <div className="align-items-center">
            {contact
              .filter((c) => c.showInHeader)
              .map((c, index) => (
                <div
                  key={index}
                  className="align-items-center Whatsapp-any-query me-3"
                >
                  <Link
                    to={`https://wa.me/${c.contactNumber}`}
                    target="_blank"
                    className="text-decoration-none"
                  >
                    <img src={whatsapp} alt="whatsapp" height={22} width={22} />
                  </Link>

                  <span className="mx-2 d-none d-sm-inline fs-5">
                    WhatsApp for any query:
                  </span>

                  <Link
                    to={`https://wa.me/${c.contactNumber}`}
                    target="_blank"
                    className="color-white num-hover text-decoration-none fs-5 bold"
                  >
                    {formatContactNumber(c.countryName, c.contactNumber)}
                  </Link>
                </div>
              ))}
          </div>
          {/* <Link
        to="/become-a-tutor"
        className="d-flex align-items-center text-decoration-none color-white gap-2 mt-0 mt-md-0 flex-shrink-0"
      >
        <img
          src={tutorLogo}
          alt="Become a Tutor"
          height={25}
          width={25}
        />
        <span className="fw-semibold fs-5 ">Become a Tutor</span>
      </Link> */}
        </div>
      </div>
    </div>
  );
};

export default Nav;
